import { render, staticRenderFns } from "./sampling_requested.vue?vue&type=template&id=a49b0750"
import script from "./sampling_requested.vue?vue&type=script&lang=js"
export * from "./sampling_requested.vue?vue&type=script&lang=js"
import style0 from "./sampling_requested.vue?vue&type=style&index=0&id=a49b0750&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports